import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";

import {
  getOutcome,
  getSuccess,
  getDatasetFromSetup,
  getSuccessOptions,
  getSuccessOptionsWarning,
  getEndState,
  updateEndState,
  updateSuccess
} from "containers/Setup/reducer";
import { getStep, updateStep } from "containers/CreateWizard/reducer";
import { updateDescription, getDescription } from "containers/Blueprint/reducer";

import ChooseSuccess from "components/CreateWizard/Outcome/ChooseSuccess";

const bId = "chooseSuccess";

class ChooseSuccessContainer extends React.PureComponent {
  handleUpdate(sel) {
    const { success, index, updateSuccess, updateStep } = this.props;

    updateStep(index + 1);

    return updateSuccess(sel);
  }

  render() {
    const { step, index } = this.props;

    return <ChooseSuccess {...this.props} updateSuccess={(success) => this.handleUpdate(success)} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateSuccess: (success) => dispatch(updateSuccess(ownProps.id, success)),
  updateStep: (step) => dispatch(updateStep(step)),
  updateDescription: (desc) => dispatch(updateDescription(ownProps.id, desc)),

  updateEndState: (endState) => dispatch(updateEndState(ownProps.id, endState))
});

const mapStateToProps = (state, ownProps) => ({
  selectedDataset: getDatasetFromSetup(state, ownProps.id),
  outcome: getOutcome(state, ownProps.id),
  success: getSuccess(state, ownProps.id),
  options: getSuccessOptions(state, ownProps.id),
  successOptionsWarning: getSuccessOptionsWarning(state, ownProps.id),
  step: getStep(state),
  description: getDescription(state, ownProps.id),

  endState: getEndState(state, ownProps.id)
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(ChooseSuccessContainer);
